module.exports = __webpack_public_path__ + "img/transparent-disclosure.c7a4f190.svg";